var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"host-stars",attrs:{"title":_vm.title}},[(_vm.stars > 0 || _vm.isSuperior)?_c('span',{staticClass:"mr-1"},[_vm._l((_vm.stars),function(star){return _c('font-awesome-icon',{key:star,attrs:{"icon":"star"}})}),(_vm.isSuperior)?_c('font-awesome-icon',{staticClass:"superior",attrs:{"icon":"s"}}):_vm._e()],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }